import { IEnvironment } from './environment.interface';
import { CMS_CONFIG_STAGE, GTM_ENV, INSURANCE_ENV_TEST, KAMELEOON_ENV, TARIFF_ENV, UC_ENV } from './shared';

export const environment: IEnvironment = {
    baseUrl: 'https://preview.saferyou.de',
    production: true,
    preview: true,
    cms: CMS_CONFIG_STAGE,
    tariff: TARIFF_ENV,
    google_tag_manager: GTM_ENV,
    usercentrics: UC_ENV,
    kameleoon: KAMELEOON_ENV,
    insurance: INSURANCE_ENV_TEST,
};
